import {sbxCoreService} from "../Network";
import {BillingParams} from "../Store/Billing/Types";
import moment from "moment";

export function getBills(params: BillingParams) {
  const toFetch = ["customer"];

  const query = sbxCoreService.with("bill")
    .andWhereIsEqualTo("pre_bill", false)
  // .andWhereIsEqualTo("bill_to.customer_to_bill", params.customer);

  if (params.all && Boolean(params.all)) {
    query.andWhereIsEqualTo("customer", params.customer)
      .orWhereIsEqualTo("customer.parent", params.customer);
  } else {
    query.andWhereIsEqualTo("customer", params.customer);
  }

  if (params.payment_date) {
    let paymentDate = moment(params.payment_date);
    query.andWhereIsGreaterOrEqualTo('payment_date', paymentDate.startOf('day').toISOString())
    query.andWhereIsLessOrEqualTo('payment_date', paymentDate.endOf('day').toISOString())
  }

  return query
    .fetchModels(toFetch)
    .loadAll(toFetch);
}
